import React from "react";
import { string } from "prop-types";
import Button from "../Button";
import { classes } from "../utils/classes";

const HeroButtonLink = ({ className = "", size = "s", ...props }) => {
	return (
		<Button.Link size={size} className={classes("section-hero__button", className)} {...props} />
	);
};
HeroButtonLink.propTypes = {
	className: string,
	size: string,
	...Button.propTypes,
};

export default HeroButtonLink;
